import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { IconButton } from '@mui/material';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import ComputerIcon from '@mui/icons-material/Computer';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const navigate = useNavigate();

  // Toggle between light and dark modes
  const handleThemeToggle = () => {
    toggleTheme(theme === 'light' ? 'dark' : 'light');
  };

  // Set theme to system mode
  const handleSystemTheme = () => {
    toggleTheme('system');
  };

  const handleDashboardRedirect = () => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  const isLoggedIn = Boolean(localStorage.getItem("token"));

  // Adjust icon color based on theme; always use black for light themes and white for dark
  const getIconColor = (themeName) => {
    if (theme === 'system') {
      // When system theme is active, use black for all icons if system theme is light, otherwise white
      return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? '#ffffff'
        : '#000000';
    }
    return theme === themeName ? 'dodgerblue' : theme === 'light' ? '#000000' : '#ffffff';
  };

  // Set profile icon color based on login status and theme
  const profileIconColor = isLoggedIn ? 'green' : getIconColor(theme);

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
      <h2 style={{ position: 'absolute', left: '10px', cursor: 'pointer' }} onClick={() => navigate('/')}>
        NexLearn
      </h2>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <LanguageSelector />
      </div>
      
      <IconButton onClick={handleDashboardRedirect}>
        <PersonIcon style={{ color: profileIconColor }} />
      </IconButton>

      {/* Toggle between light and dark icons based on current theme */}
      <IconButton onClick={handleThemeToggle} color={theme === 'light' || theme === 'dark' ? 'primary' : 'default'}>
        {theme === 'light' ? (
          <NightsStayIcon style={{ color: getIconColor('dark') }} />
        ) : (
          <WbSunnyIcon style={{ color: getIconColor('light') }} />
        )}
      </IconButton>

      {/* System theme icon, changes color based on detected system theme */}
      <IconButton onClick={handleSystemTheme} color={theme === 'system' ? 'primary' : 'default'}>
        <ComputerIcon style={{ color: getIconColor('system') }} />
      </IconButton>
    </div>
  );
};

export default ThemeToggle;
